import useAppContext from '@groupefungo/react-apollo.core/app/UseContext';

export default () => {
  const { gql, useMutation } = useAppContext();

  const DeleteNodeMutationGql = gql`
    mutation deleteNode($gid: ID!) {
      deleteNode(gid: $gid) {
        success
      }
    }  
  `;

  const useDeleteNodeMutation = () => useMutation(DeleteNodeMutationGql);

  return { useDeleteNodeMutation };
};
